module.exports = __webpack_public_path__ + "img/paypal_banner.2ca0246b.gif";